<script setup>
import SiteLogo from 'components/SiteLogo.vue';
import TextLink from 'components/TextLink.vue';
import AppRoute from 'src/router/app-route.js';
import { Route } from 'src/router/routes.js';

const legalLinks = [
    {
        label: 'Privacy Policy',
        route: AppRoute.build(Route.PrivacyPolicyPage)
    },
    {
        label: 'Terms of Service',
        route: AppRoute.build(Route.TermsOfServicePage)
    },
    {
        label: 'Contact Us',
        route: AppRoute.build(Route.ContactPage)
    }
];
</script>

<template>
    <footer>
        <div class="bg-black text-white q-py-lg">
            <div class="container-md q-px-md">
                <div class="flex column row-md justify-between items-center q-gutter-y-lg">
                    <div class="logo-container">
                        <SiteLogo width="177px" height="29px" lazy-load inverted/>
                    </div>
                    <div class="flex column row-md items-center q-gutter-x-lg">
                        <TextLink v-for="link of legalLinks" :key="link" :label="link.label" :route="link.route" class="q-mb-xs q-mb-md-none"/>
                        <q-separator color="white" class="hidden block-md q-ml-lg" vertical/>
                        <span class="q-mt-md q-mt-md-none">&copy; 2025, All Rights Reserved.</span>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
footer {
    a:link {
        font-weight: 600;
    }

    .app-logo {
        text-align: left;
    }
}
</style>
